import React from 'react';
import Progressive from './organisms/Progressive/Progressive';
import Legacy from './organisms/Legacy/Legacy';
import AccountManagement from './organisms/AccountManagement/AccountManagement';

import './App.scss';

interface AppProps {
  organism: string;
}

// Should this be dynamically imported based on the organism prop?
export default function App(props: AppProps) {
  if (props?.organism === 'account_management') {
    return <AccountManagement />;
  }
  if (props?.organism === 'legacy') {
    return <Legacy />;
  }
  return <Progressive />;
}
